/**
 * Mapping type multimédia (API Apidae / Sitra) → icône Bold.
 * Aligné sur l'enum MultimediaType et les libellés "Type de média" / "Icône".
 */

import type { MultimediaTypeEnum } from "../types/apidae.d";

const DEFAULT_ICON = "bold/files/file";

/** type → chemin d'icône (sans préfixe bold/ si déjà inclus) */
const TYPE_TO_ICON: Record<MultimediaTypeEnum, string> = {
  // Photos / Images
  IMAGE_PRINCIPALE: "bold/video_audio_sound/gallery",
  IMAGE: "bold/video_audio_sound/gallery",
  IMAGE_TOURISME_AFFAIRES: "bold/video_audio_sound/gallery",
  IMAGE_HANDICAP: "bold/video_audio_sound/gallery",
  IMAGE_PRINCIPALE_HIVER: "bold/video_audio_sound/gallery",
  IMAGE_HIVER: "bold/video_audio_sound/gallery",
  // PDF et autres fichiers
  DOCUMENT: "bold/files/file",
  // Son
  SON: "bold/video_audio_sound/volume_loud",
  // Vidéo
  VIDEO: "bold/video_audio_sound/clapperboard_play",
  // Plan et tracé GPS
  PLAN: "bold/map_&_location/routing_2",
  // Logo
  LOGO: "bold/video_audio_sound/gallery_circle",
  // Webcam
  WEBCAM: "bold/video_audio_sound/videocamera_record",
  WEBCAM_360: "bold/video_audio_sound/videocamera_record",
  // Visite virtuelle
  VISITE_VIRTUELLE: "bold/video_audio_sound/panorama",
  // Brochure virtuelle
  BROCHURE_VIRTUELLE: "bold/files/cloud_file",
  // Image bon plan
  BON_PLAN: "bold/video_audio_sound/gallery_favourite",
  // Applications
  APPLICATION_IPHONE: "bold/electronic_devices/smartphone_2",
  APPLICATION_IPAD: "bold/electronic_devices/tablet",
  APPLICATION_ANDROID: "bold/electronic_devices/smartphone_2",
  APPLICATION_ANDROID_TABLETTE: "bold/electronic_devices/tablet",
  // Chaînes / réseaux (dépréciés) → défaut fichier
  CHAINE_YOUTUBE: DEFAULT_ICON,
  CHAINE_DAILYMOTION: DEFAULT_ICON,
  GALERIE_FLICKR: DEFAULT_ICON,
  CHAINE_VIMEO: DEFAULT_ICON,
  PINTEREST: DEFAULT_ICON,
  INSTAGRAM: DEFAULT_ICON,
  SNAPCHAT: DEFAULT_ICON,
};

/**
 * Retourne le chemin d'icône pour un type multimédia.
 * @param type - Valeur de l'enum type (ex: DOCUMENT, VIDEO, WEBCAM)
 * @returns Chemin d'icône (ex: bold/files/file)
 */
export function getMultimediaTypeIconName(type: string): string {
  if (type in TYPE_TO_ICON) {
    return TYPE_TO_ICON[type as MultimediaTypeEnum];
  }
  return DEFAULT_ICON;
}
